module.exports = __webpack_public_path__ + "img/plan2.9cfc4f6.png";